import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar";
import DealSummary from "../../components/Dashboard/DealSummary";
import DoughnutReport from "../../components/Dashboard/DoughnutReport";
import BarChartSummary from "../../components/Dashboard/BarChartSummary";
import RecentDeals from "../../components/Dashboard/RecentDeals";
import PlatformOverview from "../../components/Dashboard/VerficationSummary";
import SenderIdSummary from "../../components/Dashboard/SenderIdSummary";
import Loader from "../../components/Loader";
import { toast } from "react-toastify";
import dashboardServices from "../../requests/admin/DashboardServices";

const Dashboard = () => {
  const [loading, setLoading] = useState(true);
  const [appStats, setAppStats] = useState(null);
  const [recentDeals, setRecentDeals] = useState(null);
  const [recentSenderIds, setRecentSenderIds] = useState(null);
  const [chartData, setChartData] = useState(null);
  const [timeFrame, setTimeFrame] = useState("Lifetime");

  useEffect(() => {
    const fetchDashboardStats = async () => {
      setLoading(true);
      try {
        const [appStatsResponse, chartDataResponse] = await Promise.all([
          dashboardServices.fetchAppStats(),
          dashboardServices.fetchChartData(),
        ]);

        if (appStatsResponse.status === "000") {
          setAppStats(appStatsResponse.data);
          setRecentDeals(appStatsResponse.data.recent_deals);
          setRecentSenderIds(appStatsResponse.data.recent_senderIds);
        } else {
          toast.error(
            appStatsResponse.message ||
              "An error occurred while fetching app stats"
          );
        }
        if (chartDataResponse.status === "000") {
          setChartData(chartDataResponse.data.data);
        } else {
          toast.error(
            chartDataResponse.message ||
              "An error occurred while fetching chart data"
          );
        }
      } catch (error) {
        toast.error(
          error.response?.data?.data?.reason ||
            "An error occurred while fetching dashboard stats"
        );
      } finally {
        setLoading(false);
      }
    };
    fetchDashboardStats();
  }, []);

  console.log("App Stats", appStats);

  if (loading) {
    return <Loader />;
  }
  return (
    <div className="min-h-screen bg-[#fcfcfc] overflow-x-hidden">
      <Navbar page="Dashboard" />
      <div className="px-6 py-6 mx-auto max-w-7xl">
        <DealSummary appStats={appStats} />
        <div className="grid grid-cols-1 gap-4 py-6 md:grid-cols-3">
          <div className="overflow-hidden col-span-1 bg-white rounded-xl shadow-md md:col-span-1">
            <PlatformOverview appStats={appStats} />
          </div>
          <div className="overflow-hidden col-span-1 bg-white rounded-xl shadow-md md:col-span-1">
            <DoughnutReport
              chartData={chartData}
              timeFrame={timeFrame}
              setTimeFrame={setTimeFrame}
              setChartData={setChartData}
            />
          </div>
          <div className="overflow-hidden col-span-1 bg-white rounded-xl shadow-md md:col-span-1">
            <RecentDeals recentDeals={recentDeals} />
          </div>
        </div>
        {/* <div className="grid grid-cols-1 gap-6 py-6 md:grid-cols-3">
          <div className="overflow-hidden col-span-1 bg-white rounded-xl md:col-span-2">
            <BarChartSummary />
          </div>
          <div className="overflow-hidden col-span-1 bg-white rounded-xl md:col-span-1">
            <SenderIdSummary recentSenderIds={recentSenderIds} />
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default Dashboard;
